import baseApi from "../api/baseApi";

const deletionHistoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllDeletionHistory: builder.query({
      query: ({ type = "All", startDate = "", endDate = "", page = 1 } = {}) => {
        const params = { page };

        if (type) {
          params.type = type;
        }

        if (startDate) {
          params.startDate = startDate;
        }

        if (endDate) {
          params.endDate = endDate;
        }

        return {
          url: "/deletionhistory/getAllDeletionHistory",
          method: "GET",
          credentials: "include",
          params,
        };
      },
    }),
    deleteCourseModulePermanently: builder.mutation({
      query: ({ id }) => ({
        url: `/coursemodules/deleteCourseModulePermanently/${id}`,
        method: "DELETE",
        credentials: "include",
      }),
    }),
    deleteCourseModule: builder.mutation({
      query: (payload) => ({
        url: "/coursemodules/deleteCourseModule",
        method: "PATCH",
        credentials: "include",
        body: payload,
      }),
      invalidatesTags: (result, error, { courseId } = {}) =>
        error || !courseId ? [] : [{ type: "CourseCompletion", id: courseId }],
    }),
    deleteCourseLearningOutcomePermanently: builder.mutation({
      query: ({ id }) => ({
        url: `/outcome/deleteCourseLearningOutcomePermanently/${id}`,
        method: "DELETE",
        credentials: "include",
      }),
    }),
    deleteCourseLearningOutcome: builder.mutation({
      query: ({ courseId, courseOutcomeId }) => ({
        url: `/outcome/deleteCourseLearningOutcome`,
        method: "PATCH",
        credentials: "include",
        body: { courseId, courseOutcomeId },
      }),
      invalidatesTags: (result, error, { courseId }) =>
        error || !courseId ? [] : [{ type: "CourseCompletion", id: courseId }],
    }),
    deletePdfMaterialPermanently: builder.mutation({
      query: ({ id }) => ({
        url: `/coursepdfmaterial/deletePdfMaterialPermanently/${id}`,
        method: "DELETE",
        credentials: "include",
      }),
    }),
    deletePdfMaterial: builder.mutation({
      query: ({ courseId, pdfId }) => ({
        url: `/coursepdfmaterial/deletePdf/${courseId}/${pdfId}`,
        method: "DELETE",
        credentials: "include",
      }),
      invalidatesTags: (result, error, { courseId }) => [{ type: 'PdfMaterials', id: courseId }],
    }),
    restoreCourseModule: builder.mutation({
      query: (payload) => ({
        url: "/coursemodules/restoreCourseModule",
        method: "PATCH",
        credentials: "include",
        body: payload,
      }),
    }),
    restoreCourseLearningOutcome: builder.mutation({
      query: ({ id }) => ({
        url: `/outcome/restoreCourseLearningOutcome/${id}`,
        method: "PATCH",
        credentials: "include",
      }),
    }),
    restoreCategory: builder.mutation({
      query: ({ id }) => ({
        url: `/category/${id}/restore`,
        method: "PATCH",
        credentials: "include",
      }),
      invalidatesTags: ["Categories"],
    }),
    restorePdfMaterial: builder.mutation({
      query: ({ id, itemId  }) => ({
        url: `/coursepdfmaterial/restorePdfMaterial/${id}/${itemId}`,
        method: "PATCH",
        credentials: "include",
      }),
    }),
    restoreLecture: builder.mutation({
      query: ({ lectureId }) => ({
        url: "/courselectures/restoreLecture",
        method: "PATCH",
        credentials: "include",
        body: { lectureId },
      }),
    }),
    restoreRole: builder.mutation({
      query: (payload) => {
        const roleId = String(payload.roleId || payload.id || "");

        return {
          url: "/role/restoreRole",
          method: "PATCH",
          credentials: "include",
          body: {
            ...payload,
            roleId,
            id: roleId,
          },
        };
      },
    }),
  }),
});

export const {
  useGetAllDeletionHistoryQuery,
  useDeleteCourseModulePermanentlyMutation,
  useDeleteCourseModuleMutation,
  useDeleteCourseLearningOutcomePermanentlyMutation,
  useDeleteCourseLearningOutcomeMutation,
  useDeletePdfMaterialPermanentlyMutation,
  useDeletePdfMaterialMutation,
  useRestoreCourseModuleMutation,
  useRestoreCourseLearningOutcomeMutation,
  useRestoreCategoryMutation,
  useRestorePdfMaterialMutation,
  useRestoreLectureMutation,
  useRestoreRoleMutation,
} = deletionHistoryApi;
